module.exports = __webpack_public_path__ + "static/media/mail.e6956db2.svg";